<template>
    <div v-if="isAvailable">
        <b-overlay :show="isLoading" class="d-inline-block my-1" opacity="0.6" rounded spinner-small spinner-variant="primary">
            <b-btn class="btn-card-action btn-card-action-green my-1" @click="copyPurchase">Копировать</b-btn>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-external-purchase-card-copy-button',
    props: {
        contract: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        async copyPurchase() {
            this.isLoading = true;
            try {
                const purchaseId = await this.$api.personal.fl44ExternalPurchases.copyPurchase(this.contract.id);
                if (purchaseId) {
                    await this.$router.push({ name: 'ExternalPurchaseCreate', params: { mode: 'edit_draft', id: purchaseId } });
                }
            } finally {
                this.isLoading = false;
            }
        }
    },
    computed: {
        isAvailable() {
            return this.contract.actions.copy;
        }
    }
};
</script>
